export default __webpack_public_path__ + "static/media/logo__technology__dart.f00251a3.png";